import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=2068b4d7&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
import style0 from "./TextField.vue?vue&type=style&index=0&id=2068b4d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068b4d7",
  null
  
)

export default component.exports